import { RequestService } from '../request';

import { ICreateTrackingEvent } from './tracking-event.contract';

export class TrackingEventService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  public createTrackingEvent(trackingEvent: ICreateTrackingEvent) {
    return this.poster<ICreateTrackingEvent, any>('/tracking-events', trackingEvent);
  }
}
